// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"34ee524c","591":"71ea8c1a"}[chunkId] + ".chunk.css";
};